import { isXSide, isZSide } from '../Selectors/Side';

export function fixValueWithRangeRule(value, rule) {
  if (!rule) {
    return value;
  }
  if (value > rule.max) {
    return rule.max;
  }
  if (value < rule.min) {
    return rule.min;
  }
  if (rule.values && rule.values.indexOf(value) === -1) {
    return rule.values[0];
  }
  return value;
}

export function fixBuildingDataWithRules(state, rules) {
  state.width = fixValueWithRangeRule(state.width, rules.width);
  state.height = fixValueWithRangeRule(state.height, rules.height);
  state.length = fixValueWithRangeRule(state.length, rules.length);
}

export function isObjectInRange({ side, index }, state) {
  const { xWallSegmentCount, zWallSegmentCount } = state;
  return (isXSide(side) && index < xWallSegmentCount) || (isZSide(side) && index < zWallSegmentCount);
}

export function filterObjectsInRange(state, objects = state.objects) {
  return (objects || []).filter((object) => {
    return isObjectInRange(object, state);
  });
}

export function fixValueWithFixedValueRule(value, rule) {
  if (!rule) {
    return value;
  }
  if (rule.fixedValue !== undefined && value !== rule.fixedValue) {
    return rule.fixedValue;
  }
  return value;
}
